import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface';
import { rbFilterConfig } from './filters/rbFilterConfig';
export const RBTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [
    UATConstants.PlaceholdersAndTitles.SMCRedButton,
    ' ' + UATConstants.PlaceholdersAndTitles.RedButtonTSI,
  ],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: rbFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: rbFilterConfig,
      AreaPath: [UATConstants.RedButtonSMCAreaPath, UATConstants.RedButtonTSIAreaPath],
      Title: UATConstants.TenantTitles.RedButton,
      ADOTitle: UATConstants.TenantADOText.RedButton,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateRedButtonRequest,
          Key: UATConstants.CreateActionMenuKey.CreateRedButtonRequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'redbutton',
        title: UATConstants.PlaceholdersAndTitles.RedButtonTenantName,
        excelColumnSequence: {
          'Title': 1,
          'Action Owner': 2,
          'Assigned Team': 3,
          'RB Approver': 4,
          'RB_Area': 5,
          'RB_BlockedProductOpportunityID': 6,
          'RB_BlockedUSOOpportunityID': 7,
          'RB_CaseNumber': 8,
          'RB_CompanyName': 9,
          'RB_Country': 10,
          'RB_CRMAccountID': 11,
          'RB_CSSCaseCreationDate': 12,
          'RB_CSSCaseNumber': 13,
          'RB_CurrentFYRevenue': 14,
          'RB_CustomerContactEmail': 15,
          'RB_CustomerContactName': 16,
          'RB_CustomerContactNumber': 17,
          'RB_CustomerRevenueImpacted': 18,
          'RB_CustomerTPID': 19,
          'RB_EstedBilledRevenue': 20,
          'RB_GeneralCategory': 21,
          'RB_GetHelpTicketCreationDate': 22,
          'RB_GetHelpTicketNumber': 23,
          'RB_InfraLocation': 24,
          'RB_MSFTProductBlockedRevenue': 25,
          'RB_NSCStartDate': 26,
          'RB_Region': 27,
          'RB_SalesTerritory': 28,
          'RB_SSSPEmail': 29,
          'RB_SSSPFullName': 30,
          'RB_Technology': 31,
          'RB_TicketReason': 32,
          'RB_UsersImpacted': 33,
          'RB_USOBlockedRevenue': 34,
        },
      },
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedTo', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'requestors', formFieldLabel: UATConstants.PlaceholdersAndTitles.Requestors, apiFieldName: 'requestorsinfo' },
        { formFieldName: 'rb_BlockedOpportunityRevenue', formFieldLabel: UATConstants.PlaceholdersAndTitles.Approver, apiFieldName: 'rb_approver' },
        { formFieldName: 'contributor1', formFieldLabel: UATConstants.PlaceholdersAndTitles.Contributor1, apiFieldName: 'contributorsinfo' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      systemViewsFolderId: '5d2c0a88-8d1f-476a-80ad-274d9470949f',
      sharedViewsFolderId: '7c4ec327-8986-43da-8cf9-09df268ffa73',
    },
  },
};
